// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"image-off"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.4144 6.58594C17.7763 6.94787 18.0002 7.44787 18.0002 8.00015C18.0002 9.10472 17.1047 10.0002 16.0002 10.0002C15.4479 10.0002 14.9479 9.77629 14.5859 9.41436M3.7 21H21V3.6M12.8315 3.00183L14.9978 3.00183L15 3L12.8315 3.00183ZM12.8315 3.00183L3.00215 3.00004L3.00215 13.6652M3.00215 13.6652L3.00215 15.4982L3 15.5L3.00215 13.6652ZM19.5 20.5L11.5 12.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 22L22 2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ImageOffIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'image-off',
    ref,
    icon: element,
  },
));

ImageOffIcon.displayName = 'ImageOffIcon';

export default ImageOffIcon;
